import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import moment from 'moment-timezone';
import { CallSchedulePeriod } from '../../models/interview-period.models';

const TIME_FORMAT = 'HH:mm';

/** Warns that a time clashes with the project's calls, listing them */
@Component({
  selector: 'app-interview-period-call-overlap-warning',
  templateUrl: './interview-period-call-overlap-warning.component.html',
  styleUrls: ['./interview-period-call-overlap-warning.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule],
})
export class InterviewPeriodCallOverlapWarningComponent {
  readonly calls = input.required<CallSchedulePeriod[]>();
  /** The call times are shown in this timezone */
  readonly timezoneName = input.required<string>();

  readonly overlaps = computed(() =>
    [...this.calls()]
      .sort((a, b) => a.start.localeCompare(b.start))
      .map((call) => ({
        name: call.expertName,
        time: [call.start, call.end]
          .map((time) =>
            moment(time).tz(this.timezoneName()).format(TIME_FORMAT)
          )
          .join('-'),
      }))
  );
}
